import { EventImage_BackgroundMap, getObjectByEnumMap } from 'js/utils/enum-string-maps';

import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';
import background1 from '../../assets/images/event-background.svg';
import background2 from '../../assets/images/event-background2.svg';
import background3 from '../../assets/images/event-background3.svg';
import background4 from '../../assets/images/event-background4.svg';

import background1grey from '../../assets/images/event-background-grey.svg';
import background2grey from '../../assets/images/event-background2-grey.svg';
import background3grey from '../../assets/images/event-background3-grey.svg';
import background4grey from '../../assets/images/event-background4-grey.svg';

import { IEventImage } from 'source/NFR.types';

const normalBackgrounds = {
  background1,
  background2,
  background3,
  background4
};

const greyBackgrounds = {
  background1: background1grey,
  background2: background2grey,
  background3: background3grey,
  background4: background4grey
};

let count = 0;

const getBackground = (backgrounds: typeof normalBackgrounds | typeof greyBackgrounds): string => {
  const index = count++ % 3;
  return Object.values(backgrounds)[index];
};

interface EventImageProps extends IEventImage {
  loading?: 'eager' | 'lazy' | undefined;
  fetchPriority?: 'high' | 'low' | 'auto' | undefined;
  sizes?: string;
  className?: string;
}

const EventImage: React.FC<EventImageProps> = ({
  image,
  background,
  darkFilter,
  greyFilter,
  loading = 'lazy',
  fetchPriority = 'auto',
  isEvent = false,
  sizes,
  className
}) => {
  const backgrounds = greyFilter ? greyBackgrounds : normalBackgrounds;
  const bgUrl = getObjectByEnumMap(EventImage_BackgroundMap, backgrounds, background);

  const eventImage = {
    src: image?.src || bgUrl || getBackground(backgrounds),
    alt: image?.alt || 'background',
    focusPoint: image?.focusPoint
  };

  const sizeConfig = isEvent ? imageSizes.eventImage.card : imageSizes.eventImage.article;

  return (
    <div className={['event-image', className].filter(Boolean).join(' ')}>
      <Image
        {...sizeConfig}
        {...eventImage}
        sizes={sizes}
        darkFilter={darkFilter}
        loading={loading}
        fetchPriority={fetchPriority}
        onPageEditing={{ image: eventImage.src }}
      />
    </div>
  );
};

EventImage.displayName = 'EventImage';

export default EventImage;
